import React, { useContext, useEffect, useState } from 'react';
import _ from "lodash";
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import { Avatar, Breadcrumb, Tooltip, Row, Col, Button, Dropdown, Menu, Divider, Space, Upload, Badge } from 'antd';
import { ArrowLeftOutlined, LoadingOutlined, DownOutlined, DownloadOutlined, FlagOutlined, LinkOutlined,  MessageOutlined,  PlusOutlined, UserAddOutlined, CheckCircleFilled, ShareAltOutlined } from '@ant-design/icons';
import { Header } from 'antd/lib/layout/layout';
import './ProductQA.scss'
import ENVIRONMENT from '../../../../environments';
import { getBaseURL } from '../../../../environments/env';
import * as Utilities from '../../Utilities';
import CollaborateConstants from '../CollaborateTool/Constants';
import ProductPageConstants from '../ProductComponents/ProductPageConstants';
import * as Constants from "../../CustomerComponents/Constants";
import * as Styles from "../../../../Styles";

const progress_bar = Styles.progress_bar;

const CUSTOMER_USERNAME = localStorage.getItem('username');
const IS_MSPROVIDER = localStorage.getItem('is_msprovider');
const COMPANY_ID = localStorage.getItem('company_id');
const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');

const ProductQANavigation = () => {
    const { setRefImgModal, setViewType, access_level, productAssetData, convertProductFeedbackToPDF, collaborateMode, downloadImagesArchive, productData,
        setCollaborateAccessModal, allCommentsLoaded, disablePDF, displayLoader, canvasLoader, autoSaveLoader, annotateLoader,
        initialLoader, refreshLoader, downloadCryptoImagesArchive, openCommentHistory, openShareModal, activeCollaboratorList,
        openVariantModal, projectID, collaborators, refImagePhotoList, setRefImagePhotoList, setErrorMessage,
        setSelectComparisonImageModal, isUploading, setIsUploading, setRejectionHistoryVisible } = useContext(CollaborateQAContext);

    const [showDropdown, setShowDropdown] = useState(false);
    const [allUsersActiveStatus, setAllUsersActiveStatus] = useState([]);
    
    const tabNameMapping={
        'active': 'Active Projects',
        'requested': 'Requested Projects',
        'approved': 'Approved Projects',
        'mspActive': 'Active Projects',
        'mspApproved': 'Approved Projects'
        }
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project_id")
    const projectName = urlParams.get("project_name")
    const projectTab = urlParams.get("projectTab")
    const selectedUser = urlParams.get("selectedUser")

    // Function to toggle the dropdown visibility
    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    useEffect(() => {
        const updatedList = collaborators
        .map(user => ({
            ...user,
            active:
            user.username === CUSTOMER_USERNAME ||
            activeCollaboratorList.some(activeUser =>
                activeUser.customer_username === user.username
            )
        }))
        .filter(user => user.active); // Only keep active users

          

        const colorMap = {};
        let colorIndex = 0;
        updatedList.forEach((item) => {
            if (!colorMap[item.username]) {
                colorMap[item.username] = ProductPageConstants.avatar_colors[colorIndex % ProductPageConstants.avatar_colors.length];
                colorIndex++;
            }
        });

        let colorUpdatedList = updatedList.map((item) => ({
            ...item,
            avatar_color: colorMap[item.username]
        }));
        console.log(colorUpdatedList)
        setAllUsersActiveStatus(colorUpdatedList);
      }, [collaborators, activeCollaboratorList]);      

    // Function to generate the dropdown menu
    const dropdownMenu = (
        <Menu>
            {activeCollaboratorList.map((collaborator, index) => (
                <Menu.Item key={index} className="display-flex j-s a-c">
                    <Avatar
                        className="cursor-pointer mr-12 manrope f-16 white lh-32 circle-bg light-blue">
                        {Utilities.getInitials(collaborator.name ? collaborator.name : collaborator.customer_username)}
                    </Avatar>
                    <div className="collaborator-email-username">
                        <span className="manrope f-14 w-700" style={{ display: 'block' }}>{collaborator.customer_username}</span>
                        <span className="manrope f-12 w-400" style={{ display: 'block' }}>{collaborator.email}</span>
                    </div>
                </Menu.Item>
            ))}
        </Menu>
    );


    const menu = (
        <Menu style={{ width: "200px" }}>
            <Menu.ItemGroup key={"assets"} title={<span className='manrope f-12 grey-8c'>Assets</span>} >
                <Menu.Item className='manrope f-14' key={0} onClick={() => downloadImagesArchive()}>
                    <span>All Images</span>
                </Menu.Item>
                <Menu.Item key={1} className='manrope f-14' onClick={() => downloadCryptoImagesArchive()}>
                    <span>Cryptomatte</span>
                </Menu.Item>
                <Menu.Item key={2} onClick={() => convertProductFeedbackToPDF()}
                    disabled={allCommentsLoaded || disablePDF || displayLoader || annotateLoader
                        || (canvasLoader && collaborateMode) || initialLoader || refreshLoader || autoSaveLoader}>
                    <Tooltip className='manrope f-14'
                        title={<span className='manrope f-12 white'>{disablePDF ? "No feedback exists yet" :
                            (allCommentsLoaded || displayLoader || (canvasLoader && collaborateMode) || initialLoader || refreshLoader || autoSaveLoader || annotateLoader) ?
                                "Please wait while collaboration data is being fetched." : "Download changes made in Collaboration Mode"}</span>}>
                        <span className='cursor-pointer'>Feedback (PDF)</span>
                    </Tooltip>
                </Menu.Item>
            </Menu.ItemGroup>
            {productAssetData && productAssetData.download_links && productAssetData.download_links.length > 0 &&
                <Menu.ItemGroup key={"model"} title={<span className='manrope f-12 grey-8c'>Model</span>} >
                    {(productAssetData.download_links || []).map((ele, index) => {
                        return (
                            <Menu.Item key={index + 4}>
                                <a className='manrope f-14' target="_blank"
                                    download
                                    href={ele.model_url.replace(ENVIRONMENT.DEFAULT_BASE_URL, getBaseURL(productAssetData['platform']))} >{ele.display_name}</a>
                            </Menu.Item>
                        );
                    })}
                </Menu.ItemGroup>}
        </Menu>
    );

    const getPlatform = () => {
        let product = productAssetData;
        if (product && product.hasOwnProperty('platform') && product.platform !== null) {
            return product.platform;
        } else {
            return null;
        }
    }

    const handleChangeProductPhotos = (info) => {
        setIsUploading(true)
        let fileList = [...info.fileList];
        setRefImagePhotoList(fileList);
        setSelectComparisonImageModal(true);
        if (info.file.status === "done") {
            setErrorMessage('');
            setIsUploading(false);
        } else if (info.file.status === "error") {
            setErrorMessage(info.file.error.code.concat('   ' + info.file.error.message));
            if (info.file.error.code.includes('Credentials')) {
                setErrorMessage(info.file.error.code.concat('. Your session has expired. Please reload the page.'));
            } else if (info.file.error.code.includes('Network')) {
                setErrorMessage(info.file.error.code.concat('. We are unable to upload due to an issue with your internet connection.'));
            }
            setIsUploading(false);
        }
    };

    const addRefAssets = () => {
        setViewType('comparison_view');
        setRefImgModal(true);
    }

    return (<Header className='product-nav-header white qa small-padding'>
        <Row className='display-flex j-s-b a-c'>
            <Col span={12}>
                <Breadcrumb className='display-flex j-s a-c breadcrumb-setting-product-qa'>
                { projectName && projectId ? 
                      <>
                      <Breadcrumb.Item className="manrope f-14 lh-28 black-73 white-space-text">
                          <a
                              className="manrope f-14 lh-28 black-73 white-space-text display-flex j-s a-c"
                              href={projectTab === "approved" || projectTab === "mspApproved" ? `/library-projects?tab=${projectTab}` : `/projects?tab=${projectTab}`}
                          >
                              <ArrowLeftOutlined className='mr-8'/>
                              {IS_MSPROVIDER && MANAGED_CUSTOMER_USERNAME && (projectTab == 'mspActive' || projectTab == 'mspApproved') ? `${MANAGED_CUSTOMER_USERNAME}'s ${tabNameMapping[projectTab]}` : `Your ${tabNameMapping[projectTab]}`}
                          </a>
                      </Breadcrumb.Item><Breadcrumb.Item className="manrope f-14 lh-28 black-73 white-space-text">
                              <a
                                  className="manrope f-14 lh-28 black-73 white-space-text"
                                  href={`/projects/${projectId}?tab=${projectTab}&selectedUser=${selectedUser}`}
                              >
                                  {projectName.substring(0, 15) + (projectName.length > 15 ? '...' : '')}
                              </a>
                          </Breadcrumb.Item></> : 
                    <Breadcrumb.Item>
                        <a className='manrope f-14 lh-28 black-73 white-space-text display-flex j-s a-c'
                            href={'/active-models?tab=in-review&origin=/home'}>
                            <ArrowLeftOutlined className='mr-8' />
                            {"Model Activity"}
                        </a>
                    </Breadcrumb.Item>}
                    <Breadcrumb.Item className='manrope f-14 lh-28 black-d9 clamp-text w-100'>
                        <Tooltip title={<span className='manrope f-12 white'>{productAssetData['product_name']}</span>}>
                            {productAssetData['product_name']}
                        </Tooltip>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Col>
            <Col span={12} className='display-flex j-e a-c'>
                {collaborateMode && (CollaborateConstants.edit_access_levels.includes(access_level)) && <>
                    {allUsersActiveStatus.slice(0, 4).map((collaborator, index) => (
                    <Tooltip
                        key={index}
                        placement="bottom"
                        title={
                        <span className="manrope f-12 white">
                            {collaborator.profile_name}
                        </span>
                        }
                    >
                        <div
                        style={{
                            display: 'inline-flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: 44,
                            position: 'relative',
                            marginRight: 8,
                        }}
                        >
                        <Badge
                            count={
                            collaborator.active ? (
                                <span
                                style={{
                                    backgroundColor: '#52C41A',
                                    width: 14,
                                    height: 14,
                                    borderRadius: '50%',
                                    display: 'inline-block',
                                    border: '2px solid white',
                                }}
                                />
                            ) : null
                            }
                            offset={[-5, 5]}
                        >
                            <Avatar
                            className="cursor-pointer manrope f-16 black lh-24"
                            style={{ backgroundColor: collaborator.avatar_color }}
                            size={38}
                            >
                            {Utilities.getInitials(
                                collaborator.profile_name
                                ? collaborator.profile_name
                                : collaborator.username
                            )}
                            </Avatar>
                        </Badge>

                        {(collaborator.access_level == 'owner' || collaborator.access_level == 'co-owner') && (
                            <span 
                                className="manrope black f-9 lh-16 w-700 justify-in-center capitalize"
                                style={{
                                position: 'absolute',
                                bottom: -5,
                                background: 'white',
                                borderRadius: 2,
                                padding: '0px 4px',
                                boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
                                height: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                whiteSpace: 'nowrap',
                                }}
                            >
                                {collaborator.access_level}
                            </span>
                          
                        )}
                        </div>
                    </Tooltip>
                    ))}


                    {allUsersActiveStatus.length > 4 && (
                        <div>
                            <Avatar
                                className="cursor-pointer manrope f-16"
                                onClick={() => setCollaborateAccessModal(true)}
                                style={{lineHeight: '48px', width: '48px', height: '48px'}}>
                                +{allUsersActiveStatus.length - 4}
                            </Avatar>
                        </div>
                    )}
                    {collaborateMode &&
                    <Tooltip title={<span className='manrope f-12 white'>Invite Collaborators</span>}>
                        <Button
                            className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8 ml-6'
                            ghost
                            onClick={() => setCollaborateAccessModal(true)}>
                            <UserAddOutlined />
                        </Button>
                    </Tooltip>}
                    {allUsersActiveStatus.length > 0 && <Divider type="vertical" className='collab-nav-divider mr-16' />}
                </>}
                {(CollaborateConstants.edit_access_levels.includes(access_level)) && productData && productData.model_status == 4 &&
                    <Tooltip title={<span className='manrope f-12 white'>Download Options</span>}>
                        <Dropdown overlay={menu} trigger={['click']}>
                            <Button
                                className='product-btn inverted-black pd-11-11 f-16 br-4 square mr-8'
                                ghost>
                                <DownloadOutlined />
                            </Button>
                        </Dropdown>
                    </Tooltip>}

                {(["co-owner", "owner"].includes(access_level)) && productData && productData.model_status == 4 &&
                    <Tooltip title={<span className='manrope f-12 white'>Public Links</span>}>
                        <Button className='product-btn inverted-black  pd-11-11 f-16 br-4 square mr-8' onClick={openShareModal} ghost><ShareAltOutlined /></Button>
                    </Tooltip>}

                {collaborateMode && <Tooltip title={<span className='manrope f-12 white'>Comment History</span>}>
                    <Badge dot offset={[-21, 11]}
                            style={{ backgroundColor: '#D93025', width: 10, height: 10, minWidth: 10}}
                        >
                        <Button className='product-btn inverted-black  pd-11-11 f-16 br-4 square mr-8' ghost onClick={openCommentHistory}>
                            <MessageOutlined />
                        </Button>
                    </Badge>
                </Tooltip>}

                {(CollaborateConstants.edit_access_levels.includes(access_level)) && productData && productData.model_status == 4 &&
                    <Tooltip title={<span className='manrope f-12 white'>Rejection History</span>}>
                        <Button className='product-btn inverted-black  pd-11-11 f-16 br-4 square mr-8' ghost onClick={() => setRejectionHistoryVisible(true)}>
                            <img src={'/img/collaborate_tool/version_history_black.svg'}/>
                        </Button>
                    </Tooltip>}
                {projectID != null && (CollaborateConstants.edit_access_levels.includes(access_level)) &&
                    <Tooltip title={<span className='manrope f-12 white'>Generate Product Variant</span>}>
                        <Button
                            className='new-product-btn black f-14 mr-8'
                            onClick={openVariantModal}
                            style={{padding: '10px 16px'}}>Generate Product Variant</Button>
                    </Tooltip>}

                
                    {(CollaborateConstants.edit_access_levels.includes(access_level)) && collaborateMode ? <Button
                        icon={<PlusOutlined />}
                        onClick={() => addRefAssets()}
                        className='new-product-btn black f-14'
                        style={{padding: '10px 16px', display: 'flex', alignItems: 'center'}}
                        >Add Reference Assets
                        {isUploading ? <LoadingOutlined style={{marginLeft: '8px'}} /> : ''} 
                    </Button> : ''}
               
            </Col>
        </Row>
    </Header>)
}

export default ProductQANavigation;